import { Link } from "react-router";
import { cn } from "@util/helpers";

export type SectionMastheadProps = {
  /** The classname of the component. */
  className?: string;
  /** The link of the masthead. */
  link?: string;
  /** The masthead attributes. */
  masthead?: {
    src: string;
    width: number;
    height: number;
    alt: string;
  };
};

/** This component displays the masthead, used in display masthead logos with link. */
const SectionMasthead = ({
  className = "",
  link,
  masthead,
}: SectionMastheadProps): React.ReactElement => {
  return (
    <div className={cn(className)} data-testid="section-masthead-component">
      {link && masthead && masthead.src ? (
        <Link to={link}>
          <img
            className="w-full"
            src={masthead.src}
            width={masthead.width}
            height={masthead.height}
            alt={masthead.alt}
          />
        </Link>
      ) : null}
    </div>
  );
};

export default SectionMasthead;
